// extracted by mini-css-extract-plugin
export default {"container":"style_container__JBs4P","arrowContainer":"style_arrowContainer__N-UKF"};